import { getGetLabelListQueryKey, getGetLabelQueryKey } from '@modusign/openapi-client-category';
import { useQueryClient } from 'react-query';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';

export const useInvalidateLabelList = () => {
  const workspaceId = useWorkspaceId();

  const queryClient = useQueryClient();

  return () => queryClient.invalidateQueries(getGetLabelListQueryKey(workspaceId));
};

export const useInvalidateLabel = () => {
  const workspaceId = useWorkspaceId();

  const queryClient = useQueryClient();

  return (labelId: string) =>
    queryClient.invalidateQueries(getGetLabelQueryKey(workspaceId, labelId));
};
